export const BETA_PANEL_QUERY_KEY = 'beta'

export const hasBetaPanelQuery = (
    query: Record<string, unknown> | undefined | null,
) => {
    if (!query) return false

    return Object.prototype.hasOwnProperty.call(query, BETA_PANEL_QUERY_KEY)
}

export const betaPanelQuery = () => ({
    [BETA_PANEL_QUERY_KEY]: null,
})

export const preservedBetaPanelQuery = (
    query: Record<string, unknown> | undefined | null,
): Record<string, null> => (
    hasBetaPanelQuery(query) ? betaPanelQuery() : {}
)
